/*
/!**
 @ngdoc controller
 @name FilterTableCtrl

 @description
 This controller is used by Invoice Viewer (the revamped version)

 *!/
(function() {
    'use strict';
    var FilterTableCtrl = function($scope, logService, ajaxCall, xmsNotificationFactory, keyValueObjectService, progressBarService, filterDataService) {

        var logObj;
        $scope.DEBUG = false;
        if($scope.DEBUG){
            console.log('FilterTableCtrl loaded');
            console.log('$scope',$scope);
        }

        /!**
         * Calling this will run an AJAX post request, to the provided searchURL passing a provided ng model as searchParams for that request.
         * Example: <button type="button" class="btn btn-primary" ng-click="getSearchData('${searchUrl}',formModel)"><g:message code="default.button.search.label" default="Search" /></button>
         * @param searchUrl - URL to collect the data
         * @param searchParams - ng Model that contains search params
         *!/
        $scope.getSearchData = function(searchUrl,searchParams){
            getSearchData(searchUrl,searchParams);
        };

        /!**
         * Initialize the controller - Sets the ajax state to paused and exposes the filter data service
         * @param DEBUG - turns on various logging features to help debug controller
         * @param i18nUrl - url to i18n controller action service
         *!/
        $scope.init = function(DEBUG, cacheFormattedValues, hasActions, hasCheckbox, i18nUrl){
            $scope.DEBUG = DEBUG;
            logObj = logService.init('FilterTableCtrl',DEBUG);
            getI18n(i18nUrl);
            $scope.cacheFormattedValues = cacheFormattedValues;
            $scope.hasActions = true;//includeActions;
            $scope.hasCheckbox = true;//includeCheckbox;
            $scope.ajaxState = ajaxStateOption.PAUSED;
            //expose all the filter services
            $scope.filterDataService = filterDataService;
        };

        /!**
         * Set of i18n values
         * TODO: More work on this in future to load these from a i18n service
         * @type {{code: {default: String},{code: {default: String},{code: {default: String},..}}
         *!/
        $scope.i18n = {
            'default.button.search.label':               {default:'Search'},
            'spinner.alt':                               {default:'Loading...'},
            'default.actions.label':                     {default:'Actions'},
            'default.filterTable.sortBy.label':          {default:'Sort by'},
            'default.filterTable.filterCondition.label': {default:'Filter condition'},
            'default.filterTable.filterValue.label':     {default:'Filter value'},
            'default.filterTable.clearFilter.label':     {default:'Clear filter'},
            'default.filterTable.clear.button':          {default:'×'}
        };

        /!**
         * Called by public method, This will run an AJAX post request, to the provided searchURL passing a provided ng model as searchParams for that request.
         * @param searchUrl - URL to collect the data
         * @param searchParams - ng Model that contains search params
         *!/
        var getSearchData = function(searchUrl,searchParams){
            //identifier, params, returnData, isDeepDebug
            logObj.log('getSearchData()',[searchUrl,searchParams]);
            $scope.ajaxState = ajaxStateOption.LOADING;
            ajaxCall.getData(searchUrl, searchParams).then(function (response) {
                logObj.log('getSearchData() response.data',response.data);
                $scope.responseData = response.data;
                $scope.ajaxState = ajaxStateOption.COMPLETED;
            }, function (response) {
                console.error('AJAX Fail:', response.data);
                $scope.ajaxState = ajaxStateOption.FAILED;
            });
        };

        /!**
         * Set of ajax state options to signify the AJAX requests state
         * @type {{PAUSED: string, LOADING: string, LOADING_PROGRESS: string, COMPLETED: string, FAILED: string}}
         *!/
        var ajaxStateOption = {
            PAUSED:'PAUSED',LOADING:'LOADING',LOADING_PROGRESS:'LOADING_PROGRESS',COMPLETED:'COMPLETED',FAILED:'FAILED'
        };

        /!**
         * will eventually get i18n from server
         * TODO: More work on this in future to load these from a i18n service
         *!/
        var getI18n = function(i18nUrl){
            if(i18nUrl){
                ajaxCall.getData(i18nUrl,$scope.i18n).then(function (response) {
                    if(response.data) {
                        $scope.i18n = response.data
                    } else {
                        getI18nFailover();
                    }
                }, function (response) {
                    console.error('AJAX Fail:', response.data);
                    getI18nFailover();
                });
            } else {
                getI18nFailover();
            }
        };

        var getI18nFailover = function(){
            for(var code in $scope.i18n){
                $scope.i18n[code].value = $scope.i18n[code].default;
            }
        };

    };

    FilterTableCtrl.$inject = ['$scope', 'logService', 'ajaxCall', 'xmsNotificationFactory', 'keyValueObjectService', 'progressBarService', 'filterDataService'];
    angular.module('app').controller('FilterTableCtrl', FilterTableCtrl);
}());*/
